import produce from 'immer';

import {
  AC_LOOKUP_BY_ID_FAILURE,
  AC_LOOKUP_BY_ID_REQUEST,
  AC_LOOKUP_BY_ID_SUCCESS,
  AC_LOOKUP_FAILURE,
  AC_LOOKUP_REQUEST,
  AC_LOOKUP_SUCCESS,
  AC_RESET,
} from '@actions/actionCenter';

const initialState: IActionCenterStore = {
  lookupId: null,
  outcome: null,
  matches: [],
  isFetching: false,
  errorStatus: null,
};

const getStatus = (action: any): number | null =>
  (action.originalError && action.originalError.response && action.originalError.response.status) || null;

export default (state: IActionCenterStore = initialState, action: any) =>
  produce(state, (draftState: IActionCenterStore) => {
    switch (action.type) {
      case AC_LOOKUP_REQUEST:
      case AC_LOOKUP_BY_ID_REQUEST:
        draftState.isFetching = true;
        draftState.errorStatus = null;

        return;

      case AC_LOOKUP_SUCCESS:
      case AC_LOOKUP_BY_ID_SUCCESS:
        draftState.lookupId = action.response.lookupId;
        draftState.outcome = action.response.outcome;
        draftState.matches = action.response.matches || [];
        draftState.isFetching = false;
        draftState.errorStatus = null;

        return;

      case AC_LOOKUP_FAILURE:
      case AC_LOOKUP_BY_ID_FAILURE:
        draftState.isFetching = false;
        draftState.errorStatus = getStatus(action);

        return;

      case AC_RESET:
        draftState.lookupId = null;
        draftState.outcome = null;
        draftState.matches = [];
        draftState.isFetching = false;
        draftState.errorStatus = null;

        return;
    }
  });
